import { Stack } from '@mui/material';
import { useState, useMemo, useEffect } from 'react';
import { Button} from '@mui/material';
import { MuiOtpInput } from 'mui-one-time-password-input';
import LoadingButton from '@mui/lab/LoadingButton';
import { ReactComponent as Preview } from "./../../icons/previousButton.svg";
import { ReactComponent as PhoneOtpIcon } from "./../../icons/MFAicons/phoneOtpIcon.svg";
import { ReactComponent as EmailOtpIcon } from "./../../icons/MFAicons/emailOtpIcon.svg";


import "./OtpVerification.css"
import { useDispatch, useSelector } from 'react-redux';
import { setmfaLoading } from '../../context/toolbarSlice';


const OtpVerification = (props) => {
  const [open, setOpen] = useState(props?.open);
  const [otp, setOtp] = useState("");
  const [seconds, setSeconds] = useState(30); // 30 sec to re-send OTP
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const isSip = props?.isSip || false;
  const email = props?.email ? true : false;
  const phoneNumber = props?.phoneNumber || '';
  const firstPart = phoneNumber.slice(0, 2); 
  const lastPart = phoneNumber.slice(-3); 
  const middleMasked = phoneNumber.length > 5 ? "*".repeat(phoneNumber.length - 5) : "*".repeat(phoneNumber.length - 2);
  const maskedEmail = email && maskEmail(props.email);
  const mfaLoading = useSelector((state) => state.toolbar.mfaLoading);

  let buttonStyle = useMemo(() => ({
    borderRadius: '8px',
    height: '44px',
    fontSize: '14px',
    fontWeight: 400,
    backgroundColor: '#3D8BF8'
  }), []);

  const onClickPreviousButton = () => {
    if(isSip && email){
      props.CloseAndLogout();
    } else {
      setOpen(false);
      props.onClose();
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        clearInterval(interval);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [seconds]);

  const handleChange = (newValue) => {
    setOtp(newValue);
    setError('');
  };

  const resendOTP = () => {
    setOtp("");
    setError('');
    setSeconds(30);
    props.onClickResend();
  };

  const VerifyOTP = (e) => {
    dispatch(setmfaLoading(true));
    props.onClickVerify(otp, handleVerificationError);
  };

  const handleVerificationError = () => {
    dispatch(setmfaLoading(false));
    setError("Verification Failed, try again with a new OTP");
  };

  function maskEmail(email) {
    const [localPart, domain] = email.split('@');
    if (localPart.length <= 3) {
      return `${'*'.repeat(localPart.length)}@${domain}`;
    }
    const visiblePart = localPart.slice(-3);
    const maskedPart = '*'.repeat(localPart.length - 3);
    return `${maskedPart}${visiblePart}@${domain}`;
  }

  // Handle pressing "Enter" key to trigger OTP verification
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Enter' && otp.length === 6 && !loading) {
        VerifyOTP();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [otp, loading]);
  return (
    <div className='admin-change-password-form'>
      <div className='oz-tb-otp-verification-container'>
        <Stack direction={'row'} display={'flex'}>
          <div className='oz-tb-otp-main-header-container'>
            <Button className='oz-tb-otp-verify-back-button' onClick={onClickPreviousButton}>
              <Preview className='oz-tb-otp-verification-back-button-icon'/><label style={{marginLeft:"5px"}}>back</label>
            </Button>
            <label className='oz-tb-otp-main-header-label'>Enter OTP</label>
          </div>
        </Stack>
        <div className='oz-tb-otp-verify-lock-img'>
          {props.otpType === "sms" ? 
            <div className='oz-tb-otp-icon-and-label'>
              <PhoneOtpIcon />
              <label>Please enter the 6 digit code</label>
              <label>received on your phone number</label>
              <label>{firstPart + middleMasked + lastPart}</label>
            </div> :
            <div className='oz-tb-otp-icon-and-label'>
              <EmailOtpIcon />
              <div className='oz-tb-email-otp-verification-label'>
                <label>Please enter the 6 digit code</label>
                <label>received on your email</label>
                <label>{maskedEmail}</label>
              </div>
            </div>
          }
        </div>
        <div className="col-text-center">
          <div className='oz-tb-otp-box'>
            <MuiOtpInput length={6} TextFieldsProps={{ size: 'small', placeholder: '-', type: "password" }} value={otp} onChange={handleChange} />
          </div>
          <label className='oz-tb-otp-verify-error-msg'>{error}</label>
          <div className="countdown-text" style={{ display: 'grid', direction: 'row', marginBottom: '10px' }}>
            <LoadingButton disabled={!otp || otp.length < 6} sx={buttonStyle} type="submit" size="large" onClick={VerifyOTP} loading={mfaLoading} variant="contained">
              Login
            </LoadingButton>
            <div className='oz-tb-otp-timer-label'>
              <label className='oz-tb-otp-not-yet-received-label'>Not received yet?</label> 
              {seconds > 0 ? (
                <div className='oz-tb-otp-resend-timer-box'>
                 <label className='oz-tb-otp-resend-otp-in-label'>Resend OTP in 0: {seconds < 10 ? `0${seconds}` : seconds}</label>
                 </div>
              ) : (
                <Button disabled={seconds > 0} onClick={resendOTP} sx={{ marginLeft: '0px', marginTop: '0px', height: "15px" }}>
                  Resend Code
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtpVerification;
